import { useFormContext } from 'react-hook-form';
import RadioInput from './components/RadioInput';
import React, { useState } from 'react';
import CustomScroll from './components/CustomScroll';
const Step5 = () => {
    var _a;
    const options = [
        "10mm",
        "25mm",
        "50mm",
        "150mm",
        "250mm"
    ];
    const [hoveredValue, setHoveredValue] = useState(null);
    const { watch } = useFormContext();
    const selectedValue = watch("tolerance");
    const displayOption = (_a = hoveredValue !== null && hoveredValue !== void 0 ? hoveredValue : selectedValue) !== null && _a !== void 0 ? _a : null;
    return (React.createElement(CustomScroll, null,
        React.createElement("div", { className: "modal-grid" },
            React.createElement("div", { className: "modal-left-column" },
                React.createElement("h2", null, "Set your tolerance level"),
                React.createElement("p", null, "Define the accuracy or tolerance needed to ensure precision in the final results"),
                React.createElement("div", { className: "radio-grid tolerance-grid" }, options.map((option, idx) => (React.createElement(RadioInput, { className: "form-check-input", id: `tolerance-${idx}`, name: "tolerance", label: option, key: idx, onHover: setHoveredValue }))))),
            React.createElement("div", { className: "modal-right-column" },
                React.createElement("div", { className: "tolerance-image-grid tolerance-10" },
                    React.createElement("div", { className: "tolerance-number" }, displayOption),
                    React.createElement("div", { className: "tolerance-gap" }),
                    React.createElement("div", { className: "tolerance-image file-type-stack" },
                        displayOption &&
                            React.createElement("img", { width: "528", height: "600", src: `/assets/images/quote-modal/tolerance/${displayOption}.webp`, alt: "Building cross-section", className: "img-fluid file-image", loading: "lazy" }),
                        React.createElement("img", { width: "528", height: "600", src: `/assets/images/quote-modal/tolerance/10mm.webp`, alt: "Building cross-section", className: "img-fluid file-image", loading: "lazy" })))))));
};
export default Step5;
